<template>
    <div>
        <b-modal hide-footer size="md" centered ref="UnityTypeImages" id="UnityTypeImages" title="ADICIONAR IMAGEM E PDF"
            class="centralizatexto">
            <template #modal-title>
                <div class="header-title">ADICIONAR IMAGEM E PDF</div>
            </template>
            <div class="d-flex justify-content-center mt-2">
            </div>
                <div>
                <div
                  id="dropzone"
                  @dragenter.prevent.stop="onDragEnter"
                  @dragover.prevent.stop="onDragOver"
                  @drop.prevent.stop=""
                >
                    <div>
                        <!-- PARA DEIXAR UM DO LADO DO OUTRO -->
                        <b-tabs v-model="tabIndex" fill>
                            <b-tab :title="'PDF E IMAGEM DA PLANTA'">
                                <template slot="title">
                                    <div>
                                        <span class="d-md-down-none pl-1 text-third text-tabs">PDF e Imagem Da Planta</span>
                                    </div>
                                </template>
                                <div class="planPDF">
                                    <h5 class="title-icon-import-files">PDF e Imagem Da Planta</h5>
                                    <div v-if="dataFiles.length <= 0">
                                        <input class="inputHidden" :multiple="true"  v-on:change="sendArquivo" type="file" />
                                        <div class="body-img-pdfplanta">
                                            <div class="iconUpload" @dragleave.prevent.stop="onDragLeave" v-on:click="addImg" id="body-drag" @drop.prevent="sendArquivo">
                                                <i class="fas fa-cloud-upload-alt" style="color:#046437;"></i>
                                                <span class="textAnexo">Anexe o arquivo</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="dataFiles.length > 0" :class="`scrollImg ${dataFiles.length > 0 ? '' : 'invisible'} `">
                                        <div class="gridPDFScroll">
                                            <div class="body-img" v-for="data in dataFiles" :key="data.id">
                                                <button @click="removeFile(data.id)" class="remove-button">X</button>
                                                <img class="img-flex mx-3 my-2" id="myImg" v-if="data.tipo === 5"  @click="teste"  :src="'data:image/jpeg;base64,' + data.arquivo.arquivo" />
                                                    <div class="pdf-class mx-3 my-2" v-else>
                                                        <i class="fas fa-file-pdf"></i>
                                                        <div class="footer-imgs">
                                                            <p class="name-file">
                                                                {{data.arquivo.extensao}}
                                                            </p>
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab :title="'Tabela de Preço em PDF'">
                                <template slot="title">
                                    <div>
                                        <span class="d-md-down-none pl-1 text-third text-tabs">Tabela de Preço em PDF</span>
                                    </div>
                                </template>
                                <h5 class="tituloTabPrecoPdf">Tabela de Preço em PDF</h5>
                                <div class="tabePDF">
                                <div v-if="dataFilesTabPrec == null">
                                    <input class="inputHidden tabprec" :multiple="true"  v-on:change="sendArquivoTabPrec" type="file" />
                                    <div class="TabPrecoPDF">
                                        <div class="iconUpload" @dragleave.prevent.stop="onDragLeave" v-on:click="addImgTabPrec" id="body-drag" @drop.prevent="sendArquivoTabPrec">
                                            <i class="fas fa-cloud-upload-alt" style="color:#046437;"></i>
                                            <span class="textAnexo">Anexe o arquivo</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="tabPreçoPdf" v-if=" dataFilesTabPrec !== null">
                                        <div class="body-img">
                                            <button @click="removeFile(dataFilesTabPrec.id)" class="remove-button">X</button>
                                                <img class="img-flex mx-3 my-2" id="myImg" v-if="data.tipo === 5"  @click="teste"  :src="'data:image/jpeg;base64,' + dataFilesTabPrec.id" />
                                            <div class="pdf-class mx-3 my-2" v-else @click="openPopup">
                                                <i class="fas fa-file-pdf"></i>
                                                <div class="footer-imgs">
                                                    <p class="name-file">{{dataFilesTabPrec.arquivo.extensao}}</p>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </b-modal>

            <!-- The Modal -->
            <div id="myModal" class="modal">

            <!-- The Close Button -->
            <span class="close">&times;</span>

            <!-- Modal Content (The Image) -->
            <img class="modal-content" id="img01">

            <!-- Modal Caption (Image Text) -->
            <div id="caption"></div>
            </div>
    </div>
</template>

<script>
import UnityTypeSelector from './UnityTypeSelector'
export default UnityTypeSelector
</script>

<style scoped>
.img-flex {
    width: 250px;
    height: 200px;
}
.inputHidden {
    visibility: hidden;
}
#body-drag{
    display: grid;
    width: 250px;
    border: 1px solid black;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 50px;
    border-radius: 10px;
    align-self: end;
}

.body-img-pdfplanta{
    display: flex;
    justify-content: center;
}

.gridPDFScroll{
    display: flex;
    align-items:center;
}

.img-tabPreçoPdf{
    display: flex;
    justify-content: center;
}

.tabPreçoPdf{
    display: flex;
    justify-content: center;
}

.tituloTabPrecoPdf{
    text-align: center;
}
.addinput {
    height: 100%;
    width: 100%;
    position: absolute;
    visibility: hidden;
}

.check-title {
    height: 20px;
    width: 20px;
    position: absolute;
    top: 8px;
    left: 5px;
    padding-left: 20px;
}

.name-file{
    margin-top: 10px;
    font-size: 15px;
}

.footer-imgs{
    bottom: 0;
    height: 35px;
    width: 100%;
    z-index: 50;
    display: flex;
    justify-content: center;
    border-radius: 0 0 10px 10px;
    align-items: center;
    color: white;
    background: rgba(0, 0, 0, 0.801);
    position: absolute;
}

.import-file{
    display: flex;
    font-size: 50px;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.scrollImg{
    border-bottom: 1px solid #D4D4D4;
    display: flex;
    justify-content: center;
    width: 100%;
    margin-left: 1rem;
    gap: 25px;
    min-height: 246px;
    overflow: auto;
    border-bottom: 1px solid #D4D4D4;
}

.scrollImg  ::-webkit-scrollbar-track {
    background-color: #F4F4F4;
}
.scrollImg  ::-webkit-scrollbar {
    width: 6px;
    background: #F4F4F4;
}
.scrollImg  ::-webkit-scrollbar-thumb {
    background: #dad7d7;
}
.container::-webkit-scrollbar-track {
    background-color: #F4F4F4;
}
.container::-webkit-scrollbar {
    width: 6px;
    background: #F4F4F4;
}
.container::-webkit-scrollbar-thumb {
    background: #dad7d7;
}

.scrollImg .invisible{
    visibility: hidden;
}

.TabPrecoPDF{
    display: flex;
    justify-content: center;
}

.planPDF{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.tabePDF{
    grid-area: tabePDF;
    text-align: center;
    grid-template-rows: 1fr;
    justify-content: space-around;
}

.title-icon-import-files{
    text-align: center;
}

.img-body-info {
    width: 100%;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.body-img{
    position: relative;
}
.remove-button{
  height: 34px;
  top: 8px;
  z-index: 5;
  right: 15px;
  width: 40px;
  color: white;
  background-color: red;
  border-radius: 0px 8px 0px 15px;
  position: absolute;
  display: flex;
  border: none;
  justify-content: center;
  align-items: center;
}
.pdf-class{
    height: 200px;
    cursor: pointer;
    width: 250px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 50px;
    color: black;
    border: 1px solid black;
    border-radius: 10px;
}

.Icon {
    width: 250px;
    border: 1px solid black;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 50px;
    border-radius: 10px;
    color: black;
    cursor: pointer;
}

.img-body-dawnload {
    margin-left: 2%;
    width: 270px;
    height: 185px;
    font-size: 50px;
    color: grey;
    border-radius: 10px;
    position: relative;
    flex-direction: column;
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px dotted grey;
}

.centralizatexto {
    text-align: center;
    align-items: center;
}

#add-new-user {
    font-size: 28px;
    background-color: #008144;
    outline: transparent;
    color: white;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border: transparent;
}

.container-modal {
    position: fixed;
    bottom: calc(50px - 1vh);
    right: 10px;
}

.container-user-form {
    display: grid;
    column-gap: 10px;
    row-gap: 10px;
    justify-content: center;
    grid-template-rows: 10% 1fr 1fr 10% 1fr 1fr;
    grid-template-columns: repeat(10, 1fr);
}

#input-group-name {
    grid-row: 2;
    grid-column: 1/5;
}

#input-group-email {
    grid-row: 2;
    grid-column: 5/8;
}

#input-group-dateBirth {
    grid-row: 2;
    grid-column: 8/11;
}

#input-group-creci {
    grid-row: 3;
    grid-column: 1;
}

#input-group-uf-creci {
    grid-row: 3;
    grid-column: 2;
}

#input-group-rg {
    grid-row: 3;
    grid-column: 3/5;
}

#input-group-cpf {
    grid-row: 3;
    grid-column: 5/7;
}

#input-group-cellphone {
    grid-row: 3;
    grid-column: 7/9;
}

#input-group-comercial-phone {
    grid-row: 3;
    grid-column: 9/11;
}

#input-group-cep {
    grid-row: 5;
    grid-column: 1;
}

#input-group-city {
    grid-row: 5;
    grid-column: 2/4;
}

#input-group-address {
    grid-row: 5;
    grid-column: 4/8;
}

#input-group-district {
    grid-row: 5;
    grid-column: 8/10;
}

#input-group-number {
    grid-row: 5;
    grid-column: 10;
}

#input-group-type {
    margin-left: 20%;
    grid-row: 7;
    grid-column: 1;
}

#input-group-type2 {
    grid-row: 7;
    grid-column: 2;
}

.container-buttons-form {
    grid-row: 8;
    grid-column: 1/11;
}

.title-1,
.title-2 {
    color: #008148;
}

.title-3 {
    color: #008148;
    font-weight: 800;
}

.title-1 {
    grid-row: 1;
}

.title-2 {
    grid-row: 4;
}

.title-3 {
    grid-row: 6;
}

.container-buttons-form {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
}

.button-delete,
.button-cancel,
.button-save {
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
}

.button-cancel {
    background-color: #dedede;
    color: #747474;
}

.button-save {
    background-color: #008148;
    color: white;
}
.button-delete{
  background-color: #be2b2b;
  color: white;
}

/* estilização do cabeçalho do popup */

.container-hearder {
    background-color: #008144;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    align-items: center;
    padding: 25px 0;
}

.title-hearder {
    color: white;
    grid-column: 1;
    grid-row: 1;
    text-transform: uppercase;
    justify-self: center;
}

.container-close-button {
    grid-column: 1;
    grid-row: 1;
    justify-self: end;
    align-self: center;
}

.container-close-button img {
    width: 32px;
}

/* Style the Image Used to Trigger the Modal */
#myImg {
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}

.button-delete:hover {opacity: 0.7;}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}

/* Modal Content (Image) */
.modal-content {
  margin: auto;
  margin-top: 1%;
  display: block;
  width: 80%;
  max-width: 700px;
}
.buttonImage[data-v-3164f3a8] {
    position: absolute;
    color: black;
    border: none;
    width: 15px;
    font-weight: bold;
    z-index: -1;
    right: 7%;
    top: 15px;
    height: 15px;
    font-size: 17px;
    border-radius: 6px;
}

.breadcrumb[data-v-5806b3d1] {
    position: fixed;
    width: 100%;
    z-index: -1;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

/* Add Animation - Zoom in the Modal */
.modal-content, #caption {
  animation-name: zoom;
  animation-duration: 0.6s;
}
.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}

@keyframes zoom {
  from {transform:scale(0)}
  to {transform:scale(1)}
}

/* The Close Button */
.close {
  position: absolute;
  top: 12px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

.modal[data-v-7f0648e0] {
    display: none;
    position: fixed;
    padding-top: 100px;
    left: 0;
    top: 0;
    z-index: 10000;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.9);
}

.textAnexo {
    font-family: 'Segoe UI';
    font-size: 14px;
}

.iconUpload {
    display: flex;
    flex-direction: column;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
  .modal-content {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/UnityTypeSelector/UnityTypeSelector.vue